/* ============================================================
   Melt & Mold — PDP CRO Scripts  v2.3
   File: assets/pdp-cro.js
   Changes: WhatsApp button moved directly after buy-buttons,
            styled to match theme variables
   ============================================================ */

(function () {
  'use strict';

  var WHATSAPP_NUMBER = '919104397718';
  var OFFER_CODE = '';

  /* ── UTIL ── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function getProductTitle() {
    var el = qs('.product-info .h3, .product-info h1, .product-info h2, .product-info .h2');
    return el ? el.textContent.trim() : document.title.split('–')[0].trim();
  }

  function getPrice() {
    var el = qs('.product-info [data-money], .product-info .price__sale [data-money]');
    return el ? el.textContent.trim() : '';
  }

  /* ── 1. SAVINGS PILL ── */
  function injectSavingsPill() {
    qsa('[data-money-compare-at]').forEach(function (compareEl) {
      var compareVal = parseFloat(compareEl.dataset.moneyCompareAt || 0);
      var priceEl = compareEl.closest('.price-list, .price');
      if (!priceEl) return;
      var saleEl = qs('[data-money-sale-price], .price__sale [data-money]', priceEl);
      if (!saleEl) return;
      var saleVal = parseFloat(saleEl.dataset.moneyFull || saleEl.dataset.money || 0);
      if (compareVal <= saleVal || saleVal === 0) return;
      var pct = Math.round((compareVal - saleVal) / compareVal * 100);
      if (pct < 1) return;
      var existing = qs('.pdp-savings-pill', priceEl);
      if (existing) { existing.textContent = pct + '% OFF'; return; }
      var pill = document.createElement('span');
      pill.className = 'pdp-savings-pill';
      pill.textContent = pct + '% OFF';
      saleEl.insertAdjacentElement('afterend', pill);
    });
  }

  /* ── 2. WHATSAPP BUTTON — directly after buy-buttons (below BUY IT NOW) ── */
  function injectWhatsApp() {
    if (!WHATSAPP_NUMBER) return;
    if (document.querySelector('.pdp-whatsapp')) return; /* already injected */
    var anchor = qs('buy-buttons, .buy-buttons');
    if (!anchor) return;
    var title = encodeURIComponent('Hi! I want to order: ' + getProductTitle() + ' (' + getPrice() + ')');
    var a = document.createElement('a');
    a.className = 'pdp-whatsapp';
    a.href = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + title;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>' +
      ' Order on WhatsApp';
    anchor.insertAdjacentElement('afterend', a);
  }

  /* ── 3. INLINE TRUST MINI-BADGES — after WhatsApp ── */
  function injectTrustMini() {
    var anchor = qs('.pdp-whatsapp');
    if (!anchor) return;
    if (document.querySelector('.pdp-trust-mini')) return;
    var wrap = document.createElement('div');
    wrap.className = 'pdp-trust-mini';
    wrap.innerHTML = [
      '<div class="pdp-trust-mini__item"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>100% Genuine</div>',
      '<div class="pdp-trust-mini__item"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>Fast Ship</div>',
      '<div class="pdp-trust-mini__item"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>7-Day Returns</div>',
      '<div class="pdp-trust-mini__item"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>COD Available</div>'
    ].join('');
    anchor.insertAdjacentElement('afterend', wrap);
  }

  /* ── 4. PAYMENT ICONS BAR — after trust mini ── */
  function injectPaymentBar() {
    var trustMini = qs('.pdp-trust-mini');
    if (!trustMini || document.querySelector('.pdp-payment-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'pdp-payment-bar';
    bar.innerHTML =
      '<p class="pdp-payment-bar__label">Secure payments via</p>' +
      '<div class="pdp-payment-bar__icons">' +
        '<span class="icon-badge icon-badge--upi">• UPI</span>' +
        '<span class="icon-badge icon-badge--cod">• COD</span>' +
        '<span class="icon-badge icon-badge--razorpay">• Razorpay</span>' +
        '<span class="icon-badge icon-badge--emi">• EMI</span>' +
      '</div>' +
      '<p class="pdp-payment-bar__secure">' +
        '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>' +
        ' 256-bit SSL encrypted checkout' +
      '</p>';
    trustMini.insertAdjacentElement('afterend', bar);
  }

  /* ── 5. BOTTOM STICKY BUY BAR (mobile only) ── */
  function initStickyBar() {
    if (window.innerWidth >= 1000) return;
    if (qs('.pdp-sticky-buy')) return;
    var bar = document.createElement('div');
    bar.className = 'pdp-sticky-buy';
    var img = qs('.product-gallery img, .product__media img');
    if (img) {
      var thumb = document.createElement('img');
      thumb.className = 'pdp-sticky-buy__thumb';
      thumb.src = img.src;
      thumb.alt = '';
      thumb.loading = 'lazy';
      bar.appendChild(thumb);
    }
    var info = document.createElement('div');
    info.className = 'pdp-sticky-buy__info';
    info.innerHTML =
      '<span class="pdp-sticky-buy__title">' + getProductTitle() + '</span>' +
      '<span class="pdp-sticky-buy__price">' + getPrice() + '</span>';
    bar.appendChild(info);
    var btn = document.createElement('button');
    btn.className = 'pdp-sticky-buy__btn';
    btn.type = 'button';
    btn.textContent = 'Add to Cart';
    btn.addEventListener('click', function () {
      var mainAtc = qs('buy-buttons [type="submit"], .buy-buttons [type="submit"], form[action*="/cart/add"] [type="submit"]');
      if (mainAtc) { mainAtc.click(); }
      else {
        var buyBox = qs('.product-info');
        if (buyBox) buyBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
    bar.appendChild(btn);
    document.body.appendChild(bar);
    var hero = qs('.shopify-section--main-product, [id*="main-product"]');
    if (!hero) return;
    var observer = new IntersectionObserver(
      function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      },
      { rootMargin: '-80px 0px 0px 0px' }
    );
    observer.observe(hero);
  }

  /* ── INIT ── */
  function init() {
    injectSavingsPill();
    injectWhatsApp();   /* 1st: right after buy-buttons */
    injectTrustMini();  /* 2nd: after WhatsApp */
    injectPaymentBar(); /* 3rd: after trust mini */
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('variant:changed', function () {
    setTimeout(injectSavingsPill, 120);
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:updated', function () {
    setTimeout(injectSavingsPill, 120);
  });

})();
